import { Container, Link, Text } from '@loomhq/lens';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { showErrorBar } from 'actions/errorBar';
import { updateDeletionPending, updateUserInfo } from 'actions/user';
import { ERROR, SUCCESS } from 'constants/error-severities';
import { getGraphQLClient } from 'utilities/graphql';

import { selectCurrentUser } from 'selectors/user';

import { CancelPendingDeletion } from './CancelPendingDeletion.gql';

import './styles.less';

const DeletionPendingBanner = () => {
  const dispatch = useDispatch();
  const currentUser = useSelector(selectCurrentUser);

  const showBanner = Boolean(currentUser.deletion_pending);

  const gqlClient = getGraphQLClient();

  const cancelPendingDeletion = async () => {
    try {
      const resp = await gqlClient.mutate({
        mutation: CancelPendingDeletion,
        fetchPolicy: 'no-cache',
      });

      const success = Boolean(resp.data.cancelPendingDeletion?.success);

      if (!success) {
        throw Error('Failed to cancel pending deletion');
      }

      dispatch(updateDeletionPending(false));

      dispatch(
        showErrorBar(
          SUCCESS,
          "Your account's pending deletion has been canceled."
        )
      );
      currentUser.deletion_pending = false;
      dispatch(updateUserInfo(currentUser));
    } catch (err) {
      dispatch(
        showErrorBar(ERROR, 'Oops! Failed to cancel your pending deletion.')
      );
    }
  };

  return showBanner && gqlClient ? (
    <div className="banner">
      <Container
        width="100%"
        backgroundColor="offWhite"
        padding="medium"
        radius="medium"
      >
        <Text alignment="center">
          <Text fontWeight="bold" isInline>
            This account will be deleted once your billing cycle is over.
          </Text>{' '}
          <Text isInline>
            <Link
              className="linkWithoutUnderline"
              onClick={() => cancelPendingDeletion()}
            >
              Undo this action
            </Link>
          </Text>
        </Text>
      </Container>
    </div>
  ) : (
    <div />
  );
};

export default DeletionPendingBanner;
